// GenerarPDF.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatRemuneracion, cleanRemuneracion2 } from '../Validations/TrabajadoresValidation';
import { getEmpresaByNombre } from '../Componentes/empresasConfig';

export const generarPDFVenta = (rows, datosSueldo) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const marginLeft = 20;
    const marginRight = 20;
    const contentWidth = pageWidth - marginLeft - marginRight;

    // Color azul oscuro principal
    const azul = [27, 42, 74];

    const empresaInfo = getEmpresaByNombre(datosSueldo.empresa);
    const rutEmpresa = empresaInfo ? empresaInfo.rutFormatted : "";

    const obtenerFechaFormateada = (diasSumar = 0) => {
        const fecha = new Date();
        fecha.setDate(fecha.getDate() + diasSumar);
        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const numeroCot = String(datosSueldo.numerocotizacion || datosSueldo.idCotizacion);

    // ====== HEADER ======
    // Nombre empresa (izquierda)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(...azul);
    doc.text(String(datosSueldo.empresa), marginLeft, 30);

    // RUT empresa
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text("RUT: " + rutEmpresa + "  |  Los Carrera Poniente 301, piso 2", marginLeft, 37);

    // Caja azul derecha con número de cotización
    const boxWidth = 55;
    const boxHeight = 22;
    const boxX = pageWidth - marginRight - boxWidth;
    const boxY = 18;
    doc.setFillColor(...azul);
    doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 2, 2, "F");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(255, 255, 255);
    doc.text("COTIZACION", boxX + boxWidth / 2, boxY + 8, { align: "center" });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("N° " + numeroCot, boxX + boxWidth / 2, boxY + 17, { align: "center" });

    // ====== LINEA SEPARADORA ======
    let y = 48;
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.8);
    doc.line(marginLeft, y, pageWidth - marginRight, y);

    // ====== DATOS DEL DOCUMENTO ======
    y = 58;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);

    doc.setFont("helvetica", "bold");
    doc.text("Fecha:", marginLeft, y);
    doc.setFont("helvetica", "normal");
    doc.text(obtenerFechaFormateada(), marginLeft + 30, y);

    doc.setFont("helvetica", "bold");
    doc.text("Válido hasta:", marginLeft + 80, y);
    doc.setFont("helvetica", "normal");
    doc.text(obtenerFechaFormateada(parseInt(datosSueldo.duracionCotizacion, 10)), marginLeft + 115, y);

    // ====== DATOS DEL CLIENTE ======
    y = 70;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(...azul);
    doc.text("DATOS DEL CLIENTE", marginLeft, y);

    y = 72;
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);

    y = 80;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);

    const labelX = marginLeft;
    const valueX = marginLeft + 28;
    const col2LabelX = marginLeft + 95;
    const col2ValueX = marginLeft + 120;

    doc.setFont("helvetica", "bold");
    doc.text("Nombre:", labelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.nombreEmpresa), valueX, y);

    doc.setFont("helvetica", "bold");
    doc.text("RUT:", col2LabelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.rutempresa), col2ValueX, y);

    y += 6;
    doc.setFont("helvetica", "bold");
    doc.text("Dirección:", labelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.direccion), valueX, y);

    doc.setFont("helvetica", "bold");
    doc.text("Teléfono:", col2LabelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.telefono), col2ValueX, y);

    y += 6;
    doc.setFont("helvetica", "bold");
    doc.text("E-mail:", labelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.email), valueX, y);

    // ====== TITULO COTIZACION ======
    y = 105;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(...azul);
    doc.text("CONCEPTO", marginLeft, y);

    y = 107;
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);

    y = 114;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    const tituloLines = doc.splitTextToSize(datosSueldo.TituloCotizacion, contentWidth);
    doc.text(tituloLines, marginLeft, y);
    y += tituloLines.length * 5 + 5;

    // ====== SECCION DETALLE ======
    y += 3;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(...azul);
    doc.text("DETALLE", marginLeft, y);

    const detLineY = y + 2;
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, detLineY, pageWidth - marginRight, detLineY);

    y += 8;

    // ====== TABLA ======
    const serviceColumns = ["N°", "Cantidad", "Unidad", "Artículos", "Valor", "Valor Neto"];
    const serviceRows = rows.map((row) => [
        row.item || "",
        row.cantidad,
        row.unidad,
        row.articulos,
        `$${formatRemuneracion(String(row.valor))}`,
        `$${formatRemuneracion(String(row.valorneto))}`,
    ]);

    const totalValorNeto = rows.reduce((sum, row) => sum + cleanRemuneracion2(row.valorneto || 0), 0);
    doc.autoTable({
        startY: y,
        head: [serviceColumns],
        body: serviceRows,
        margin: { left: marginLeft, right: marginRight },
        styles: {
            lineColor: [220, 220, 220],
            lineWidth: 0.1,
            halign: 'center',
            textColor: [60, 60, 60],
            fontSize: 9,
            cellPadding: 4,
        },
        headStyles: {
            fillColor: [245, 245, 245],
            textColor: [...azul],
            fontStyle: 'bold',
            lineColor: [200, 200, 200],
            lineWidth: 0.2,
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        columnStyles: {
            0: { cellWidth: 15 },
            4: { halign: 'right', cellWidth: 28 },
            5: { halign: 'right', cellWidth: 28 },
        },
    });

    // ====== TABLA TOTAL (separada, alineada con últimas 2 columnas) ======
    doc.autoTable({
        startY: doc.lastAutoTable.finalY,
        body: [["TOTAL NETO", `$${formatRemuneracion(String(totalValorNeto))}`]],
        margin: { left: pageWidth - marginRight - 56, right: marginRight },
        showHead: false,
        styles: {
            lineColor: [220, 220, 220],
            lineWidth: 0.2,
            textColor: [...azul],
            fontSize: 10,
            fontStyle: 'bold',
            cellPadding: 4,
            halign: 'right',
        },
        columnStyles: {
            0: { cellWidth: 28 },
            1: { cellWidth: 28 },
        },
    });

    let finalY = doc.lastAutoTable.finalY + 5;

    // ====== CONDICION DE PAGO Y OBSERVACION ======
    finalY += 15;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);

    const infoValueX = marginLeft + 40;

    if (datosSueldo.CondicionPago) {
        doc.setFont("helvetica", "bold");
        doc.text("Condición de pago:", marginLeft, finalY);
        doc.setFont("helvetica", "normal");
        doc.text(String(datosSueldo.CondicionPago), infoValueX, finalY);
        finalY += 5;
    }

    if (datosSueldo.Observacion) {
        doc.setFont("helvetica", "bold");
        doc.text("Observación:", marginLeft, finalY);
        doc.setFont("helvetica", "normal");
        const obsLines = doc.splitTextToSize(datosSueldo.Observacion, contentWidth - infoValueX + marginLeft);
        doc.text(obsLines, infoValueX, finalY);
    }

    // ====== FOOTER ======
    const footerY = pageHeight - 15;
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, footerY - 5, pageWidth - marginRight, footerY - 5);

    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    const footerText = `${datosSueldo.empresa}  |  RUT: ${rutEmpresa}  |  Documento generado electrónicamente`;
    doc.text(footerText, pageWidth / 2, footerY, { align: "center" });

    // Guardar PDF
    doc.save("Cotización_" + numeroCot + ".pdf");
};

export default generarPDFVenta;
